import { MaskitoOptions, MaskitoPreprocessor, maskitoTransform } from '@maskito/core';
import { CountryType } from '../../core';

const uppercasePreprocessor: MaskitoPreprocessor = ({ elementState, data }, actionType) => ({
  elementState,
  data: actionType === 'insert' ? data.toUpperCase() : data,
});

const stripLeadingWhitespacePreprocessor: MaskitoPreprocessor = ({ elementState, data }, actionType) => ({
  elementState,
  data: actionType === 'insert' ? data.trimStart() : data,
});

export class PostalCodeUtils {
  static readonly canadaMaskitoOptions: MaskitoOptions = {
    mask: [/[A-Za-z]/, /\d/, /[A-Za-z]/, ' ', /\d/, /[A-Za-z]/, /\d/],
    preprocessors: [stripLeadingWhitespacePreprocessor, uppercasePreprocessor],
  };

  static readonly usaMaskitoOptions: MaskitoOptions = {
    // Dynamic mask: 12345 or 12345-6789
    mask: ({ value }) => {
      const hasHyphen = value.includes('-');
      if (hasHyphen || value.length > 5) {
        return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
      return [/\d/, /\d/, /\d/, /\d/, /\d/];
    },
  };

  static getMaskitoOptions(countryCode: CountryType): MaskitoOptions {
    return countryCode === CountryType.Canada
      ? PostalCodeUtils.canadaMaskitoOptions
      : PostalCodeUtils.usaMaskitoOptions;
  }

  static normalize(value: string | null | undefined, countryCode: CountryType): string {
    if (!value) return '';
    const trimmed = value.trimStart();
    const raw = countryCode === CountryType.Canada ? trimmed.toUpperCase() : trimmed;
    return maskitoTransform(raw, PostalCodeUtils.getMaskitoOptions(countryCode));
  }
}
